import {
  BudgetOptions,
  ExpenditureOptions,
} from '../constants-repository/project-calculation.constants';

// //////////////  Expenditure rate options
const ExpenditureRateGroup = 'Verrechnung nach Aufwand';
const NotBillableGroup = 'Nicht verrechenbar';

// value consists of label + group for dropdown control
export const EXPENDITURE_RATE_LABELS: Record<
  ExpenditureOptions,
  { label: string; category: string }
> = {
  [ExpenditureOptions.HourlyRateFixed]: {
    label: 'Stundensatz einheitlich',
    category: ExpenditureRateGroup,
  },
  [ExpenditureOptions.HourlyRatePerMember]: {
    label: 'Stundensatz pro Projektmitglied',
    category: ExpenditureRateGroup,
  },
  [ExpenditureOptions.HourlyRatePerTask]: {
    label: 'Stundensatz pro Aufgabe',
    category: ExpenditureRateGroup,
  },
  [ExpenditureOptions.ExpendituresInHours]: {
    label: 'Aufwand in Stunden',
    category: NotBillableGroup,
  },
} as const;

// //////////////  Budget options
export const BUDGET_LABELS: Record<BudgetOptions, string> = {
  [BudgetOptions.NoBudget]: 'Kein Budget',
  [BudgetOptions.TotalProjectMonetaryBudget]: 'Gesamte Projektkosten',
  [BudgetOptions.TotalProjectHours]: 'Gesamte Projektstunden',
  [BudgetOptions.MonetaryPerTask]: 'Projektbudget in Euro pro Aufgabe',
  [BudgetOptions.HoursPerTask]: 'Projektbudget in Stunden pro Aufgabe',
  [BudgetOptions.HoursPerMember]: 'Projektstunden pro Projektmitglied',
} as const;

// //////////////  Reset Budget options
export enum ResetBudgetOptions {
  Monthly,
  OnceAt,
}

export const RESET_BUDGET_LABELS: Record<ResetBudgetOptions, string> = {
  [ResetBudgetOptions.Monthly]: 'monatlich',
  [ResetBudgetOptions.OnceAt]: 'einmalig am',
} as const;
